export default "__VITE_ASSET__CLGQp7ki__"